import { render, staticRenderFns } from "./Rule59ResponseInstructions.vue?vue&type=template&id=539e21f1&scoped=true"
import script from "./Rule59ResponseInstructions.vue?vue&type=script&lang=ts"
export * from "./Rule59ResponseInstructions.vue?vue&type=script&lang=ts"
import style0 from "./Rule59ResponseInstructions.vue?vue&type=style&index=0&id=539e21f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539e21f1",
  null
  
)

export default component.exports